import { combineReducers } from 'redux-immutable'
import leaveEntitlementListReducer from './leave-entitlement-list-reducer'
import leaveEntitlementGetReducer from './leave-entitlement-get-reducer'
import leaveEntitlementCreateReducer from './leave-entitlement-create-reducer'
import leaveEntitlementEditReducer from './leave-entitlement-edit-reducer'
import leaveEntitlementDeleteReducer from './leave-entitlement-delete-reducer'

export default combineReducers({
  leaveEntitlementList: leaveEntitlementListReducer,
  leaveEntitlementGet: leaveEntitlementGetReducer,
  leaveEntitlementCreate: leaveEntitlementCreateReducer,
  leaveEntitlementEdit: leaveEntitlementEditReducer,
  leaveEntitlementDelete: leaveEntitlementDeleteReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/leave-entitlement/index.js